import React, { FC } from 'react';
import { SvgWithTooltip } from './SvgWithTooltip';
import { SVGTooltipProps } from '../../utils';

export const UserAvailable: FC<SVGTooltipProps> =({ onClick, divClassName, tooltip }) => (
  <SvgWithTooltip 
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle 
        cx="12" 
        cy="12" 
        r="12" 
        fill="#1F905C"
      />
      <g clipPath="url(#clip0_2541_3244)">
        <path 
          d="M9.99896 14.8001L7.19896 12.0001L6.26562 12.9334L9.99896 16.6667L17.999 8.66673L17.0656 7.7334L9.99896 14.8001Z" 
          fill="white" 
          fillOpacity="0.94"
        />
      </g>
      <defs>
        <clipPath id="clip0_2541_3244">
          <rect 
            width="16" 
            height="16" 
            fill="white" 
            transform="translate(4 4)"
          />
        </clipPath>
      </defs>
    </svg>
  </SvgWithTooltip>
);
